<template>
    <heads>
        <div class="p-6 bg-white border-b border-gray-200 overflow-hidden shadow-sm sm:rounded-lg">
            <breeze-table :searchable="true" :fields="fields" :items="contacts" :action="{'text':'add contact','url':route('heads.contact.create')}" :searchlink="route('heads.contact.search')"  :canView="this.$page.props.auth.user.role.permissions.find(permission => permission.name === 'View Contact')" :canCreate="this.$page.props.auth.user.role.permissions.find(permission => permission.name === 'Create Contact')">
                <template #action="data">
                    <button-link v-if="this.$page.props.auth.user.role.permissions.find(permission => permission.name === 'Edit Contact')" :href="route('heads.contact.edit',data.item.id)" >Edit</button-link>
                </template>
            </breeze-table>
        </div>
    </heads>
</template>

<script>
    import Heads from '@/Pages/Heads/Heads'
    import BreezeTable from '@/Components/Table'
    import ButtonLink from '@/Components/ButtonLink'

    export default {
        components: {
            Heads,
            BreezeTable,
            ButtonLink
        },
        props:['contacts'],
        data(){
            return{
                fields:[{'key':'name','label':'Name'},{'key':'mobile','label':'Mobile'},{'key':'alternate_mobile','label':'Alternate Mobile'},{'key':'email','label':'Email'},{'key':'action','label':'Action'}]
            }
        }
    }
</script>
